import React, { Component } from "react";
import styles from "./Home.module.scss";
import ImageCarousel from "../../ImageCarousel/ImageCarousel";
import Servcies from "../../ServicesPane/Services";

class Home extends Component {
  render() {
    return (
      <div>
        <ImageCarousel
          carouselIndex={0}
          nextIndex={1}
          fading={"no"}
          inTransition={false}
        />
        <div id={styles.overviewContainer}>
          <div id={styles.overview}>
            <div id={styles.header}>Welcome to Powder Solutions.</div>
            <div id={styles.overviewParagraph}>
              We’ve been providing quality pulverizing and screening services
              since 1999. We handle all material formats from 50 lb bags to 2000
              lb supersacks. Our flexible manufacturing designs allow us to
              tailor our production setup to your exact processing needs.
            </div>
            <div id={styles.overviewParagraph}>
              We are located in the suburban Philadelphia area; convenient to
              major transportation routes as well as the Port of New York and
              Philadelphia for your importing and exporting needs.
            </div>
            <div id={styles.overviewParagraph}>
              Click on the icons below to learn about our services.
            </div>
          </div>
        </div>
        <Servcies />
      </div>
    );
  }
}

export default Home;
